import { Modal } from 'react-bootstrap';
import { MdContentCopy } from 'react-icons/md';
import { BsGlobe2 } from 'react-icons/bs';
import { fetchWrapper } from '../../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../../../_helpers/_methods';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { VscLoading } from 'react-icons/vsc';

export default function ModalOverlay(props) {
  const [shareLink, setShareLink] = useState('');
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    const getShareLink = async () => {
      setLoading(true);
      try {
        const response = await fetchWrapper.get(`/event/${id}/share/`);
        let url = `${window.location.origin}/events/${id}/view/${response.data.token}`;
        setShareLink(url);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        ErrorMessageHandler(err);
      }
    };
    getShareLink();
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(shareLink);
    toast.success('लिङ्क प्रतिलिपि गरिएको छ');
  };
  return (
    <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <div className="d-flex align-items-center  rounded-3 bg-soft-primary text-primary text-lg me-2">
          <BsGlobe2 size={45} />
        </div>
        <div>
          <h5 className="mb-1">Share to web</h5>
          <small className="d-block text-xs text-muted">Publish and share link with anyone</small>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex align-items-center mb-3">
          <div>
            <p className="text-sm text-muted">
              Anyone with this link <span className="font-bold text-heading">can view</span>
            </p>
          </div>
        </div>
        <div>
          <div className="input-group input-group-inline">
            <input type="text" className="form-control border" defaultValue={shareLink} />{' '}
            {loading ? (
              <VscLoading className="spin" size={35} />
            ) : (
              <span className="input-group-text pointer-cursor" onClick={handleCopy}>
                <MdContentCopy size={25} />
              </span>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button onClick={handleCopy} className="btn btn-outline-success" type="button">
          Copy Link
        </button>
      </Modal.Footer>
    </Modal>
  );
}
